import { computed, type Ref } from 'vue'
import { defaultGetItemId } from './gpx-select-option-utils'
import { useGpxSelectResolvedOption } from './useGpxSelectResolvedOption'
import type { UseGpxLocalSelectOptions } from '../remote-select/types'

export type { UseGpxLocalSelectOptions } from '../remote-select/types'

export function useGpxLocalSelect<T>(options: UseGpxLocalSelectOptions<T>) {
  const getItemId = options.getItemId ?? defaultGetItemId<T>

  const baseOptions = computed(() => {
    const value = options.options
    return typeof value === 'object' && value != null && 'value' in value
      ? (value as Ref<T[]>).value
      : value
  })

  const { resolvedSelected, cacheSelected } = useGpxSelectResolvedOption<T>({
    modelValue: options.modelValue,
    getItemId,
    resolveSelected: options.resolveSelected,
    clearWhenFoundInItems: true,
    findInItems: (value) =>
      baseOptions.value.find((item) => getItemId(item) === value) ?? null,
  })

  return {
    options: baseOptions,
    loading: computed(() => false),
    resolvedSelected,
    showEmptyMessage: computed(() => false),
    onFilter: () => {},
    onOverlayShow: () => {},
    virtualScrollerOptions: computed(() => undefined),
    totalRecords: computed(() => baseOptions.value.length),
    cacheSelected,
  }
}
